import { jsx } from "react/jsx-runtime";
import { useSuggestedQueries } from "../../api/cache/appConfigQueryOptions.js";
import { memo, useMemo } from "react";
import { ConciergeWelcomeFullPage } from "./ConciergeWelcomeFullPage.js";
import { ConciergeWelcomeEmbedded } from "./ConciergeWelcomeEmbedded.js";
import { usePageContext } from "../hooks/usePageContext.js";
const ConciergeWelcomeComponent = ({
  trendingSearches,
  onSearch,
  brandId,
  isEmbedded = false,
  apiBaseUrl,
  userFirstName,
  pageContext: providedPageContext,
  brandLogoUrl,
  brandName,
  conciergeName,
  searchInputValue,
  setSearchInputValue,
  handleSearch,
  isActivelyStreaming,
  isMobile
}) => {
  const { data, isLoading: isLoadingSuggestedQueries } = useSuggestedQueries(brandId, apiBaseUrl);
  const suggestedQueries = useMemo(
    () => (data == null ? void 0 : data.suggestedQuestions) || (trendingSearches == null ? void 0 : trendingSearches.map((search) => ({ query: search.text, imageUrl: "" }))) || [],
    [data == null ? void 0 : data.suggestedQuestions, trendingSearches]
  );
  const displayQueries = useMemo(() => suggestedQueries.map((item) => item.query), [suggestedQueries]);
  const hookPageContext = usePageContext();
  const pageContext = providedPageContext ?? hookPageContext;
  const commonProps = {
    displayQueries,
    isLoadingSuggestedQueries,
    onSearch,
    pageContext,
    apiBaseUrl,
    brandLogoUrl,
    brandName,
    userName: userFirstName,
    conciergeName,
    searchInputValue,
    setSearchInputValue,
    handleSearch,
    isActivelyStreaming,
    isMobile
  };
  if (isEmbedded) {
    return /* @__PURE__ */ jsx(ConciergeWelcomeEmbedded, { ...commonProps });
  }
  return /* @__PURE__ */ jsx(ConciergeWelcomeFullPage, { ...commonProps });
};
const ConciergeWelcome = memo(ConciergeWelcomeComponent);
export {
  ConciergeWelcome as default
};
//# sourceMappingURL=ConciergeWelcome.js.map
